import styled from 'styled-components';

export default styled.div`
    .vote-types {
        display: flex;
    }
`;
